export const PUSH_MENU = 'PUSH_MENU'
export const SET_LATEST_RECORD = 'SET_LATEST_RECORD'
export const SET_MENU_VARIATIONS = 'SET_MENU_VARIATIONS'
export const SET_MENU_STORE_ID = 'SET_MENU_STORE_ID'
export const RESET_MENUS = 'RESET_MENUS'
export const SET_BUSINESS_HOURS = 'SET_BUSINESS_HOURS'
export const CREATE_BUSINESS_HOUR = 'CREATE_BUSINESS_HOUR'
export const SET_BUSINESS_HOUR = 'SET_BUSINESS_HOUR'
export const SET_BUSINESS_HOUR_DIRTY = 'SET_BUSINESS_HOUR_DIRTY'
export const DELETE_BUSINESS_HOUR = 'DELETE_BUSINESS_HOUR'
